import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'divider',
    theme => `
		width: 100%;
		height: 8px;
		margin: 60px auto;
		background-color: ${theme.color.text.HB};
	`
  ]
]);
